import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-primary-color-100 p-1 rounded-lg" }
const _hoisted_2 = { class: "text-sm leading-5 font-medium text-gray-500 max-w-[176px]" }
const _hoisted_3 = { class: "text-gray-900" }

import { onMounted, ref } from "vue"
import { ClockIcon, TrashIcon } from "@heroicons/vue/outline"
import { convertTriggerEvent } from "@/shared/utils/helpers"
import ToolbarNode from "@/components/workflows/ToolbarNode.vue"

interface Props {
    type?: string
    note?: { text?: string; lastEdited?: string }
}

export default /*@__PURE__*/_defineComponent({
  __name: 'EventOccurrenceNode',
  props: {
    type: {},
    note: {}
  },
  emits: ["update:note", "removeNode", "clickOnNode"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const isNoteVisible = ref(false)
const toolbarStatus = ref("emptyClosed")
const localNote = ref(props.note)

let hideTimeout: ReturnType<typeof setTimeout>
function handleMouseEnter() {
    clearTimeout(hideTimeout)
    isNoteVisible.value = true
}

function handleMouseLeave(event: MouseEvent) {
    hideTimeout = setTimeout(() => {
        if (
            ((event.relatedTarget as Element) && (event.relatedTarget as Element).classList.contains("toolbar-node")) ||
            toolbarStatus.value !== "emptyClosed" ||
            localNote.value?.text?.length !== 0
        ) {
            return
        }
        isNoteVisible.value = false
    }, 300)
}

function handleMouseEnterToolbarNode() {
    clearTimeout(hideTimeout)
    isNoteVisible.value = true
}

function updateNote(note: { text?: string; lastEdited?: string }) {
    emits("update:note", note)
    localNote.value = note
}

onMounted(() => {
    if (localNote.value?.text?.length !== 0) {
        isNoteVisible.value = true
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ToolbarNode, {
      id: "targetElement",
      class: "toolbar-node",
      note: _ctx.note,
      isNoteVisible: isNoteVisible.value,
      status: toolbarStatus.value,
      onMouseenter: handleMouseEnterToolbarNode,
      onMouseleave: handleMouseLeave,
      "onUpdate:note": updateNote,
      "onUpdate:status": _cache[0] || (_cache[0] = ($event: any) => (toolbarStatus.value = $event)),
      "onUpdate:noteVisible": _cache[1] || (_cache[1] = ($event: any) => (isNoteVisible.value = $event))
    }, null, 8, ["note", "isNoteVisible", "status"]),
    _createElementVNode("div", {
      class: "flex gap-x-2 border-2 border-primary-color-500 rounded-full py-4.5 cursor-pointer justify-center items-center px-1 group h-16 w-72",
      onMouseenter: handleMouseEnter,
      onMouseleave: handleMouseLeave,
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('clickOnNode')))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ClockIcon), { class: "w-6 h-6 text-primary-color-600" })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createTextVNode(" Delay until ")),
        _createElementVNode("b", _hoisted_3, _toDisplayString(_unref(convertTriggerEvent)(_ctx.type)), 1)
      ]),
      _createElementVNode("div", {
        class: "hidden group-hover:block bg-gray-100 rounded-full p-1",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('removeNode')))
      }, [
        _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
      ])
    ], 32)
  ], 64))
}
}

})